<ul class="assessment-hierarchy">
  @for (program of programHierarchy; track trackByProgramId($index, program)) {
    <li class="assessment-hierarchy__item">
      @if ((selectedProgramId == null || selectedProgramId === program.id) && program.children?.length) {
        <button (click)="toggleChildrenPrograms(program)" class="item__button">
          <span [ngStyle]="{ 'padding-left': hierarchyPadding }" class='title'> {{ program.name }}</span>
          @if (!(hideArrow && program.children?.length)) {
            <span
              class="label-icon icon-chevron"
              aria-hidden="true"
              [ngClass]="selectedProgramId === program.id ? 'arrow-down' : ''"
            ></span>
          }
        </button>
        @if (program.children?.length) {
          @if (selectedProgramId === program.id) {
            <app-dashboard-assessment-hierarchy-group
              [programHierarchy]="program.children"
              (currentStateEvent)="toggleArrowStatus()"
              [hierarchyLevel]="hierarchyLevel"
              >
            </app-dashboard-assessment-hierarchy-group>
          }
        }
      }
      @if (!program.children?.length) {
        <app-dashboard-assessment-hierarchy-node
          [assessment]="program"
          [hierarchyLevel]="hierarchyLevel"
          >
        </app-dashboard-assessment-hierarchy-node>
      }
    </li>
  }
</ul>
